import React from "react";
import palette from "src/theme/palette";

const CareRoutingIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_care_routing)">
      <circle cx="24" cy="24" r="23.5" fill="#F3F3FF" stroke="#DEDFFF" />
      <path
        d="M15 19.8C15 18.1198 15 17.2798 15.327 16.638C15.6146 16.0735 16.0735 15.6146 16.638 15.327C17.2798 15 18.1198 15 19.8 15H28.2C29.8802 15 30.7202 15 31.362 15.327C31.9265 15.6146 32.3854 16.0735 32.673 16.638C33 17.2798 33 18.1198 33 19.8V25.5C33 26.8978 33 27.5967 32.7716 28.1481C32.4672 28.8831 31.8831 29.4672 31.1481 29.7716C30.5967 30 29.8978 30 28.5 30C28.0114 30 27.7671 30 27.5405 30.0535C27.2383 30.1248 26.9569 30.2656 26.7185 30.4645C26.5397 30.6137 26.3931 30.8091 26.1 31.2L24.64 33.1467C24.4229 33.4362 24.3143 33.5809 24.1812 33.6327C24.0647 33.678 23.9353 33.678 23.8188 33.6327C23.6857 33.5809 23.5771 33.4362 23.36 33.1467L21.9 31.2C21.6069 30.8091 21.4603 30.6137 21.2815 30.4645C21.0431 30.2656 20.7617 30.1248 20.4595 30.0535C20.2329 30 19.9886 30 19.5 30C18.1022 30 17.4033 30 16.8519 29.7716C16.1169 29.4672 15.5328 28.8831 15.2284 28.1481C15 27.5967 15 26.8978 15 25.5V19.8Z"
        stroke={palette.primary[500]}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 20.5022C22.1762 20.0014 22.524 19.579 22.9817 19.31C23.4395 19.0409 23.9777 18.9426 24.501 19.0324C25.0243 19.1221 25.499 19.3942 25.8409 19.8004C26.1829 20.2066 26.37 20.7207 26.3692 21.2517C26.3692 22.7506 24.1209 23.5 24.1209 23.5M24.1499 26.5H24.1599"
        stroke={palette.error[400]}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_care_routing">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CareRoutingIcon;
